import { Component, EventEmitter, Inject, Input, OnInit, Output } from "@angular/core";
import { ILocationService } from "angular";
import { Notification } from 'ng/src/app/notifications/notification.model';
import { LogService } from "../../logs/log.service";
import { Note } from "../../notes/shared/note.model";
import { NotificationService } from "../notification.service";
import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";
import { PreviewViewerService } from "ng/src/app/core/preview-viewer/preview-viewer.service";
import { FileDetailType } from "ng/src/app/files/file-details/file-details.model";

@Component({
    selector: 'notification-entry',
    templateUrl: './notification-entry.component.html',
    styleUrls: ['./notification-entry.component.css']
})
export class NotificationEntryComponent implements OnInit {
    private _notification?: Notification.Projections.WithLogName;
    @Input()
    set notification(val: Notification.Projections.WithLogName | undefined) {
        this._notification = val;
        if (val) {
            this.updatePreviousAndNext();
        }
    }
    get notification() { return this._notification };

    @Input() showNavigation: boolean = true;
    @Input() showShowAllButton = true;
    @Input() fullPage: boolean = false;
    
    get hasPrevious() {
        return this.previousNotification !== undefined;
    }
    get hasNext() {
        return this.nextNotification !== undefined;
    }

    @Output() onDismissed = new EventEmitter<undefined>();

    private previousNotification?: Notification.Projections.WithLogName;
    private nextNotification?: Notification.Projections.WithLogName;

    constructor(
        private notificationService: NotificationService,
        private logService: LogService,
        private previewService: PreviewViewerService,
        @Inject('$location') private $location: ILocationService
    ) { }

    ngOnInit() {
        // grab notification if provided an id in the url params
        const notificationId = this.$location.search()['notification'];
        if (notificationId) {
            this.notificationService.findById(notificationId).subscribe(notification => {
                if (notification) {
                    this.notification = notification;
                }
            });
        }
    }
    
    canPreviewFile(file: FileAttachment) {
        return PreviewViewerService.canPreviewFile(file);
    }
    
    previewFile() {
        if (this.notification?.fileAttachment)
            this.previewService.previewFile(this.notification.fileAttachment);
    }
    
    getPreviewIcon() {
        return PreviewViewerService.getPreviewIcon(
            FileDetailType.getType(this.notification?.fileAttachment?.contentType ?? '')
        );
    }

    goToNote(note: Note) {
        this.notificationService.openNotificationNote(note);
        this.onDismissed.emit();
    }

    downloadFile(fileId: number) {
        location.href = `/api/files/${fileId}`;
    }

    toggleRead(notification: Notification.Projections.WithLogName) {
        notification.seen = !notification.seen;
        this.notificationService.updateSeen(notification, 'seen');
    }

    previous() {
        if (!this.previousNotification!.seen) {
            this.previousNotification!.seen = true;
            this.notificationService.updateSeen(this.previousNotification!, 'seen');
        }
        
        this.notification = this.previousNotification!;
    }

    showAll() {
        this.$location.url('/notifications')
            .search('notification', this._notification!.id);
    }

    next() {
        if (!this.nextNotification!.seen) {
            this.nextNotification!.seen = true;
            this.notificationService.updateSeen(this.nextNotification!, 'seen');
        }
        
        this.notification = this.nextNotification!;
    }

    private updatePreviousAndNext() {
        this.previousNotification = this.notificationService.previousNotification(this._notification!.id);
        this.nextNotification = this.notificationService.nextNotification(this._notification!.id);
    }
}
